/* eslint-disable consistent-this */
/* eslint-disable no-invalid-this */
/* eslint-disable no-magic-numbers */

/* global jQuery */

// ------   Popover Modals Module   --------- /
// ------------------------------------------ /

function PSJPopoverModals(className, onLaunch, onClose) {

	var self = this;

	this.parentToDelegateEvents = jQuery( 'body' );

	this.trigger = '';
	this.closer = '';

	this.currentModal = '';
	this.currentTrigger = '';
	this.isActive = false;

	this.className = className;
	this.modalObject = '';

	this.onLaunch = onLaunch;
	this.onClose = onClose;

	this.events = function() {

		// Clicking on trigger
		self.parentToDelegateEvents.on(
			'click',
			self.trigger,
			function() {
				self.triggerLaunch(jQuery(this));
			}
		);

		// Clicking outside of box but inside of modal
		self.modalObject.on('click', function(event) {
			if (!jQuery('.' + self.className + '__box').has(event.target)) {
				self.closeModal();
			}
		});

		// Clicking on close button
		self.parentToDelegateEvents.on(
			'click',
			self.closer,
			function() {
				self.closeModal();
			}
		);

		// Prevent tabbing out of active modal
		jQuery.psj.accessibility.allFocusOut(self.modalObject);
		self.modalObject.on('psjallfocusout', function() {
			if (self.isActive) {
				jQuery.psj.accessibility.focusFirstTabbableElement(self.currentModal);
			}
		});
	};

	this.init = function() {

		// Define triggering element
		self.trigger = '.' + self.className + '__trigger';

		// Define closing element
		self.closer = '.' + self.className + '__closer';

		// Define PSJ modal object
		self.modalObject = jQuery('.' + self.className);

		self.events();
	};

	this.triggerLaunch = function(trigger) {

		// Set trigger
		self.setTrigger( trigger );

		// Compute modal
		const modal = jQuery(trigger.data('popover-modal'));

		// Launch it
		self.launch(modal);
	};

	this.setTrigger = function(trigger) {
		self.currentTrigger = trigger;
	};

	this.launch = function(modal) {

		// Update vars
		self.currentModal = modal;
		self.isActive = true;

		// Display modal on DOM
		self.currentModal.addClass('is-active');

		// Give HTML the overflow class
		jQuery( 'html, body' ).addClass( 'has-no-overflow' );

		// Initialize ESC key listener
		jQuery(document).on('keydown.modalESCKeydown', function(event) {
			if (event.keyCode && event.keyCode === 27) {
				self.closeModal();
			}
		});

		// Focus first tabbable element in modal
		window.setTimeout(function() {
			jQuery.psj.accessibility.focusFirstTabbableElement(self.currentModal);
		}, 0);

		// Execute onLaunch function
		if (self.onLaunch && typeof self.onLaunch === 'function') {
			self.onLaunch.call(self.currentModal, self.currentModal);
		}
	};

	this.injectModalTitle = function( modal, title ) {
		// Find the box and inject it
		modal.find( '.' + self.className + '__title' ).html( title );
	};

	this.injectModal = function(modal, content) {

		// Find the box and inject it
		modal.find( '.' + self.className + '__content' ).html( content );
	};

	this.closeModal = function() {

		// Update vars
		self.isActive = false;

		// Hide modal on DOM
		self.currentModal.removeClass('is-active');

		// Remove overflow class from HTML
		jQuery( 'html, body' ).removeClass( 'has-no-overflow' );

		// Remove ESC key listener
		jQuery(document).off('keydown.modalESCKeydown');

		// Return focus to current trigger
		window.setTimeout(function() {
			if ( self.currentTrigger.focus ) {
				self.currentTrigger.focus();
			}
		}, 0);

		// Execute onClose function
		if (self.onClose && typeof self.onClose === 'function') {
			self.onClose.call(self.currentModal, self.currentModal);
		}
	};
}

// Custom onClose function
function onCloseFunction(modal) {

	// Find any child AV
	const av = modal.find( 'audio, video' );

	// Find any child iFrames
	const iFrames = modal.find( 'iframe' );

	// If there are any child AV things, loop through them and stop them
	av.each( function( index, avElement ) {

		// Stop the element
		avElement.pause();
	} );

	// If there are any child iFrames, loop through them
	iFrames.each( function( index, iFrame ) {

		// jQueryatize the iFrame
		iFrame = jQuery( iFrame );

		// Get the element's src
		const src = iFrame.attr( 'src' );

		// Remove the source attribute
		iFrame.attr( 'src', '' );

		// Bring it back almost immediately
		window.setTimeout(
			function() {
				iFrame.attr( 'src', src );
			},
			100
		);
	} );
}

// Instantiate in window object
window.PSJPopoverModals = new PSJPopoverModals( 'js-popover-modal', '', onCloseFunction );

( function( $ ) {

	// Initialize
	$(window).on('load', function() {
		window.PSJPopoverModals.init();
	});

}( jQuery ) );



// WEBPACK FOOTER //
// ./src/js/inc/vendor/popover-modals-jquery.js